var _rect, _path, _circle, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.358,
    y: 7.395,
    width: 19.409,
    height: 31.335,
    rx: 2.134,
    ry: 2.134
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.233,34.605V5.404c0-1.179.955-2.134,2.134-2.134h17.276"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.063,
    cy: 23.063,
    r: 4.89
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.657,
    y1: 10.181,
    x2: 17.657,
    y2: 13.435
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.469,
    y1: 10.181,
    x2: 28.469,
    y2: 13.435
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.657,
    y1: 32.69,
    x2: 17.657,
    y2: 35.944
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28.469,
    y1: 32.69,
    x2: 28.469,
    y2: 35.944
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorAtm);
export default __webpack_public_path__ + "static/media/indoor-atm.70f96375749ea0a519ab585c427397bd.svg";
export { ForwardRef as ReactComponent };